import Component from "vue-class-component";
import Vue from "vue";
import {namespace} from "vuex-class";
import {LoggedInUser} from "@/store/types";

const storePath = "loggedInUser";
const Store = namespace(storePath);

@Component({name: "WithLoggedInUser"})
export default class WithLoggedInUser extends Vue {

  @Store.State((state: LoggedInUser) => state)
  public loggedInUser!: LoggedInUser;

}
